import { StorageSerializers } from '@vueuse/core'
import { LocalStorage } from '~/models'

export type EmailSentModel = {
  requestPage?: 'change-email' | 'resend-email'
  email?: string
}

export const useMyAccountLocalStorage = () => {
  const emailSentTo = useLocalStorage<EmailSentModel>(LocalStorage.EmailForChange, {
    requestPage: undefined,
    email: undefined,
  }, {
    serializer: StorageSerializers.object,
  })

  const setEmailSentTo = (data: EmailSentModel) => {
    set(emailSentTo, data)
  }

  return {
    emailSentTo,
    setEmailSentTo,
  }
}
